// The backend exposes two role axes and they are not interchangeable:
//   * `super_role` — a single string that decides which module a user lands in
//     and which Private*Route lets them through (ADMIN, LOAN_OFFICER,
//     MART_OFFICER, UNION_USER, IT_OFFICER, CUSTOMER_SERVICE).
//   * `role`       — an array of fine-grained roles used for in-module gating,
//     passed to a route via its `roles` prop (e.g. LOAN_OFFICER_HEAD gates
//     /loans/clearance).
// RolesContants below is the `role[]` vocabulary. SuperRolesContants is the
// `super_role` vocabulary. Gate module access on the latter, actions on the former.
export const RolesContants = {
    ADMIN: "ADMIN",
    LOAN_OFFICER: "LOAN_OFFICER",
    LOAN_OFFICER_AUTHORIZER: "LOAN_OFFICER_AUTHORIZER",
    LOAN_OFFICER_HEAD: "LOAN_OFFICER_HEAD",
    MART_OFFICER: "MART_OFFICER",
    MART_OFFICER_HEAD: "MART_OFFICER_HEAD",
    CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
    CUSTOMER_SERVICE_HEAD: "CUSTOMER_SERVICE_HEAD",
}

export const SuperRolesContants = {
    ADMIN: "ADMIN",
    LOAN_OFFICER: "LOAN_OFFICER",
    MART_OFFICER: "MART_OFFICER",
    UNION_USER: "UNION_USER",
    IT_OFFICER: "IT_OFFICER",
    CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
    CUSTOMER_SERVICE_HEAD: "CUSTOMER_SERVICE_HEAD",
}

// ── Ticketing vocabulary ────────────────────────────────────────────────
// Kept here (rather than inline in pages) so the queue, detail view, reports
// and the reducer all agree on the same strings the API is expected to return.

export const TicketStatus = {
    OPEN: "OPEN",
    PENDING: "PENDING",       // waiting on the member
    IN_PROGRESS: "IN_PROGRESS",
    ESCALATED: "ESCALATED",
    RESOLVED: "RESOLVED",
    CLOSED: "CLOSED",
}

export const TicketPriority = {
    LOW: "LOW",
    NORMAL: "NORMAL",
    HIGH: "HIGH",
    URGENT: "URGENT",
}

// The only priorities an agent may SET. HIGH/URGENT remain in TicketPriority so
// PriorityBadge still renders any legacy ticket that carries them, but new
// tickets and edits are limited to these two.
export const TicketPrioritySelectable = ["NORMAL", "LOW"]

// A queue maps a ticket to the department that owns it. These mirror the
// existing modules so an escalated ticket lands with the right officers.
export const TicketQueues = {
    LOANS: "LOANS",
    MART: "MART",
    FUNDS: "FUNDS",
    ACCOUNT: "ACCOUNT",
    GENERAL: "GENERAL",
}

export const TicketCategories = {
    LOANS: [
        "Loan application status",
        "Loan deduction dispute",
        "Loan settlement / clearance",
        "Loan booking query",
    ],
    MART: [
        "Order status",
        "Order delivery issue",
        "Mart deduction dispute",
        "Product enquiry",
    ],
    FUNDS: [
        "Fund contribution missing",
        "Fund increment request",
        "Dues enquiry",
    ],
    ACCOUNT: [
        "Password / account reset",
        "Device verification",
        "Profile update",
        "Membership status",
    ],
    GENERAL: [
        "General enquiry",
        "Complaint",
        "Suggestion",
    ],
}

// Hours allowed for first response / resolution, by priority. The backend is
// the source of truth for breach flags; these drive the local countdown only.
export const TicketSLA = {
    URGENT: { firstResponse: 1, resolution: 8 },
    HIGH: { firstResponse: 4, resolution: 24 },
    NORMAL: { firstResponse: 8, resolution: 72 },
    LOW: { firstResponse: 24, resolution: 120 },
}
